import React from "react";

const DEFAULT_LOGO = {
  src: "/logo-small.png",
  alt: "LeadGen AI",
  title: "LeadGen AI",
  url: "/",
};

const DEFAULT_MENU_ITEMS = [
  {
    title: "Product",
    links: [
      { text: "AI Search", url: "/search" },
      { text: "Dashboard", url: "/dashboard" },
      { text: "Pricing", url: "/pricing" },
      { text: "Email Finder", url: "/search" },
      { text: "Lead Export", url: "/search" },
    ],
  },
  {
    title: "Company",
    links: [
      { text: "About", url: "/about" },
      { text: "Contact", url: "/contact" },
      { text: "FAQ", url: "/faq" },
      { text: "Blog", url: "#" },
    ],
  },
  {
    title: "Legal",
    links: [
      { text: "Privacy Policy", url: "/privacy" },
      { text: "Terms of Service", url: "/terms" },
    ],
  },
  {
    title: "Connect",
    links: [
      { text: "Twitter", url: "#" },
      { text: "LinkedIn", url: "#" },
      { text: "Instagram", url: "#" },
      { text: "GitHub", url: "https://github.com/ankulpal983-arch" },
    ],
  },
];

const DEFAULT_BOTTOM_LINKS = [
  { text: "Terms of Service", url: "/terms" },
  { text: "Privacy Policy", url: "/privacy" },
];

export function Footer2({
  logo = DEFAULT_LOGO,
  tagline = "AI-Powered Lead Generation for Freelancers",
  menuItems = DEFAULT_MENU_ITEMS,
  copyright = "© 2025 LeadGen AI. All rights reserved.",
  bottomLinks = DEFAULT_BOTTOM_LINKS,
}) {
  return (
    <section className="py-20 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-6">
        <footer>
          <div className="grid grid-cols-2 gap-8 lg:grid-cols-6">
            {/* Logo & Tagline */}
            <div className="col-span-2 mb-8 lg:mb-0">
              <a href={logo.url} className="flex items-center gap-2">
                <img src={logo.src} alt={logo.alt} className="h-8" />
                <p className="text-xl font-semibold text-white">{logo.title}</p>
              </a>
              <p className="mt-4 text-gray-400">{tagline}</p>
            </div>

            {/* Menu Sections */}
            {menuItems.map((section, idx) => (
              <div key={idx}>
                <h3 className="mb-4 font-bold text-white">{section.title}</h3>
                <ul className="space-y-4">
                  {section.links.map((link, linkIdx) => (
                    <li key={linkIdx}>
                      <a
                        href={link.url}
                        className="text-gray-400 hover:text-blue-400 transition-colors"
                      >
                        {link.text}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom Bar */}
          <div className="mt-16 flex flex-col justify-between gap-4 border-t border-white/10 pt-8 text-sm text-gray-500 md:flex-row md:items-center">
            <p>{copyright}</p>
            <div className="flex gap-4">
              {bottomLinks.map((link, idx) => (
                <a
                  key={idx}
                  href={link.url}
                  className="underline hover:text-blue-400 transition-colors"
                >
                  {link.text}
                </a>
              ))}
            </div>
          </div>
        </footer>
      </div>
    </section>
  );
}
